(() => {
  const header = document.querySelector('.premium-navigation');
  const navigation = header.querySelector('nav');
  const toggle = header.querySelector('.menu-toggle');
  const disclosures = [...header.querySelectorAll('details')];
  // Native exclusive group also prevents two panels opening in the same frame.
  disclosures.forEach(disclosure => disclosure.setAttribute('name', 'photo-story-navigation'));
  const close = () => {
    disclosures.forEach(disclosure => { disclosure.open = false; });
    navigation.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open navigation');
  };
  // The existing PDP script toggles the mobile navigation; close nested content with it.
  toggle.addEventListener('click', () => { if (!navigation.classList.contains('open')) disclosures.forEach(disclosure => { disclosure.open = false; }); });
  disclosures.forEach(disclosure => disclosure.addEventListener('toggle', () => {
    if (disclosure.open) disclosures.forEach(other => { if (other !== disclosure) other.open = false; });
  }));
  document.addEventListener('click', event => { if (!header.contains(event.target)) close(); });
  header.addEventListener('focusout', event => { if (event.relatedTarget && !header.contains(event.relatedTarget)) close(); });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const disclosure = disclosures.find(item => item.open);
    if (disclosure) {
      disclosure.open = false;
      disclosure.querySelector('summary').focus();
      event.stopImmediatePropagation();
    } else if (navigation.classList.contains('open')) {
      close();
      toggle.focus();
    }
  }, true);
  matchMedia('(max-width:1199px)').addEventListener('change', close);
})();
